import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import CoreButton from "../CoreButton/CoreButton";
import CoreTextArea from "../CoreTextArea/CoreTextArea";
import { t } from "i18next";
import { useState } from "react";
import CoreButtonHoverIcon from "../CoreButtonIcon/CoreButtonHoverIcon";
import CoreMaxCharacter from "../CoreMaxCharacter/CoreMaxCharacter";

const CoreDialog = ({
  title,
  content,
  positiveButton,
  negativeButton,
  handlePositive,
  closeDialog,
  disabledButton,
  open,
  reject = false,
  notesDiscard,
  setNotesDiscard,
}) => {
  const [note, setNotes] = useState(false);

  return (
    <Dialog open={open} onClose={closeDialog}>
      <DialogTitle className="font-bold">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {content}
          {reject && (
            <div className="flex flex-col">
              <div className="flex w-full items-center justify-center py-4">
                <CoreButtonHoverIcon
                  className="text-red-600 m-1"
                  onClick={() => setNotes((prevSelected) => !prevSelected)}
                  testo={t("Add") + " " + t("DiscardNotes")}
                />
              </div>
              {note && (
                <div className="w-full flex items-center ">
                  <CoreTextArea
                    rows={5}
                    label={t("DiscardNotes")}
                    name="notesDiscard"
                    value={notesDiscard}
                    onChange={(e) => setNotesDiscard(e.target.value)}
                    className={"w-full"}
                    error={notesDiscard?.length > 250}
                  />
                  <CoreMaxCharacter maxCharacter={250} text={notesDiscard} />
                </div>
              )}
            </div>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions className="flex justify-center">
        <div className="flex justify-start space-x-4 mb-4">
          <CoreButton
            disabled={disabledButton}
            className="btn-round secondary"
            variant="outlined"
            testo={negativeButton}
            onClick={closeDialog}
          />
          <CoreButton
            disabled={disabledButton || notesDiscard?.length > 250}
            className="btn-round"
            variant="contained"
            testo={
              disabledButton ? (
                <CircularProgress size={20} className="text-white" />
              ) : (
                positiveButton
              )
            }
            onClick={handlePositive}
          />
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default CoreDialog;
